(() => {
  const init = (section) => {
    const container = section.querySelector(".js-slider-logos");
    if (!container || container.swiper) return;

    const slides = container.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    const nextBtn = section.querySelector(".logo-list-swiper__button--next");
    const prevBtn = section.querySelector(".logo-list-swiper__button--prev");
    const pagination = section.querySelector(".logo-list-swiper__pagination");

    new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 20,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  };

  const initLogoListSection = () =>
    document.querySelectorAll(".logo-list").forEach(init);

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", initLogoListSection)
    : initLogoListSection();

  document.addEventListener("shopify:section:load", (e) =>
    initLogoListSection(e.target)
  );
})();
